import { Component, OnInit, Input, Output, ContentChild, TemplateRef, EventEmitter } from '@angular/core';

@Component({
  selector: 'pds-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent {
   
  @Output() closed: EventEmitter<any> = new EventEmitter<any>();
  @Input() showModal = false;
  @ContentChild('title',{static: false}) titleTemplateRef: TemplateRef<any>;
  @ContentChild('body',{static: false}) bodyTemplateRef: TemplateRef<any>;
  @ContentChild('footer',{static: false}) footerTemplateRef: TemplateRef<any>;

  public localShowModal;

  constructor() { }

  ngOnChanges(){

    this.localShowModal = this.showModal;
    this.hideScrollBar();

  }

  hideScrollBar(){
    
    let body = document.querySelector("body");
    if(this.localShowModal){
      body.style.overflow = 'hidden';
    }else {
      body.style.overflow = 'visible';
    }

  }

  closeModal(){

    this.closed.emit()

  }












}
